import { defineWorld } from "@latticexyz/world";

export default defineWorld({
  namespace: "tuhe",
  tables: {
    GateAccess: {
      schema: {
        smartCharacterId: "address",
        smartGateId: "uint256",
        couldJump: "string",
      },
      key: ["smartCharacterId", "smartGateId"],
    },
  },
});
